import * as React from "react";
import {groupNumber, withCurrency} from "../../utils/number-utils";
import locales from "../../locales";
import {CostStatistics, UsageStatistics} from "../../api/dtos/statistics";
import SectionHeaderFormItem from "../../common/form-items/SectionHeaderFormItem";
import StatisticsLayoutItem from "./StatisticsLayoutItem";
import {ChartData} from "../RentimeChart";
import './Statistics.css';
import StatisticsLayout from "./StatisticsLayout";
import {Alert} from "antd";

export const renderStatHeader = (title: string): React.ReactNode => {
  return (
    <SectionHeaderFormItem title={title}/>
  );
};

export const renderStatLayout = (left: React.ReactNode, right?: React.ReactNode): React.ReactNode => {
  return (
    <StatisticsLayout
      left={left}
      right={right ? right : <></>}
    />
  );
};

export const renderTitledStatLayout = (title: string, left: React.ReactNode, right?: React.ReactNode): React.ReactNode => {
  return (
    <>
      {renderStatHeader(title)}
      {renderStatLayout(left, right)}
    </>
  );
};

export const renderStatLayoutItem = (label: string, node?: React.ReactNode): React.ReactNode => {
  return <StatisticsLayoutItem
    key={label}
    left={label === '' ? '' : label + ' :'}
    right={node ? node : <></>}
  />
};


export const renderCostStatistics = (costStats: CostStatistics): React.ReactNode => {
  return renderTitledStatLayout(
    locales.income,
    <>
      {renderPriceStatLayoutItem(locales.total_maintenance_cost, costStats.totalMaintenanceCost)}
      {renderPriceStatLayoutItem(locales.total_income, costStats.totalIncome)}
      {renderPriceStatLayoutItem(locales.profit, costStats.profit)}
    </>
  );
};

export const renderAlertStatLayoutItem = (message: string): React.ReactNode => {
  return (
    <StatisticsLayoutItem
      key={message}
      left={''}
      right={<Alert type="info" message={message} style={{marginBottom: 16}}/>}
    />
  );
};

export const renderUnitStatLayoutItem = (label: string, value: number, unit: string, color?: string, total?: number): React.ReactNode => {
  return renderStatLayoutItem(
    label,
    <>
      {color && renderLegendDot(color)}
      {groupNumber(value)} {unit}
      {renderPercentTextIfPossible(value, total)}
    </>
  );
};

export const renderPriceStatLayoutItem = (label: string, value: number, total?: number): React.ReactNode => {
  return renderStatLayoutItem(
    label,
    <>
      {withCurrency(groupNumber(value))}
      {renderPercentTextIfPossible(value, total)}
    </>
  );
};

export const renderLegendDot = (color: string): React.ReactNode => {
  return (
    <span
      className="state-dot"
      style={{background: color, marginRight: 8}}
    />
  );
};

export const renderPercentTextIfPossible = (value: number, total?: number): React.ReactNode => {
  const percent = total ? getPercentString(value, total) : undefined;
  return percent && renderSmallText(` - ${percent}%`);
};

export const renderSmallText = (text: string): React.ReactNode => {
  return (
    <span className="statistics-small-grey-text">{text}</span>
  );
};

export const getPercentString = (value: number, total: number): string => {
  return calculatePercent(value, total).toFixed(1);
};

export const calculatePercent = (value: number, total: number): number => {
  return value / total * 100;
};

export const createUsageChartData = (usageStats: UsageStatistics): ChartData => {
  return [{
    name: 'Kiadva', value: usageStats.daysRented
  }, {
    name: 'Nem használt', value: usageStats.daysUnused
  }];
};


// WEBPACK FOOTER //
// ./src/statistics/utils/statistics-utils.tsx